import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DemoInvitationPage } from '@features/auth/demo-invitation.tsx';

const searchSchema = z.object({
  token: z.string(),
});

export const Route = createFileRoute('/demo-pozvanka')({
  component: RouteComponent,
  validateSearch: search => searchSchema.parse(search),
});

function RouteComponent() {
  const { token } = Route.useSearch();

  return <DemoInvitationPage token={token} />;
}
